export function convertAPIObjectToArray(totalCaptures, graphTimeSpan) {
  let formattedCaptureData = [];
  const dataObject = totalCaptures?.graphData;

  if (dataObject) {
    for (const key in dataObject) {
      const element = dataObject[key];
      const singleObject = {
        month: key?.slice(0, graphTimeSpan === "all" ? 4 : 3),
        captures: element,
      };
      formattedCaptureData.push(singleObject);
    }
  }
  return formattedCaptureData;
}
